import { global } from "../constants";

export const data = {
  banner: {
    background: global.banner + "service7.png",
    // title: "Our Services Two",
    crumb: "Our Services",
  },

  services: {
    title: "All services",
    subtitle: "Trusted For Our Services",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.",
    services: [
      
      {
        icon: global.icons + "corporates.png",
        serial: "01",
        title: "Corporates",
        link: "/service/corporate",
        description:
          "Assisting Corporate customers to manage their end mile deliveries through EV’s and Our team (Drivers and Delivery Boys).",
      },
      {
        icon: global.icons + "warehouse.png",
        serial: "02",
        title: "Intercity",
        link: "/service/intercity",
        description:
          "Pickkup delivers reliable and eco-friendly intercity transport on key routes like Mohali → Delhi, Ludhiana, Jalandhar, Ambala, and Delhi → Jaipur. Timely, sustainable, and customer-focused logistics you can trust.",
      },
      {
        icon: global.icons + "ondemand.png",
        serial: "03",
        title: "On Demand",
        link: "/service/on-demand",
        description:
          "On Demand Platform for B2B customers assisting in their deliveries through 100% EV Fleet around  with 600+ happy customers.",
      },
    ],
  },

  estimation: {
    title: "Estimation",
    subtitle: "Has a wide range of solutions",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.",
    solutions: [
      {
        serial: "01",
        icon: global.eicons + "pic1.png",
        title: "Solutions and specialized",
        description:
          "Our aim is to optimize and improve your supply chain so that we can give you the best service",
      },
      {
        serial: "02",
        icon: global.eicons + "pic2.png",
        title: "Multiple cities",
        description:
          "We provide multiple drop-off and pickup locations across several cities, so you don’t have to worry. You won’t face any inconvenience.",
      },
      {
        serial: "03",
        icon: global.eicons + "pic3.png",
        title: "Tracking made easy",
        description:
          "A tracking number for the entire process. so that you can find the exact position.",
      },
    ],
  },

  vehicles: {
    title: "Our Fleets",
    subtitle: "",
    description:
      "EV Logistics is trusted for delivering sustainable solutions through our core services: eco-friendly intercity, on-demand B2B customer support, and tailored corporate logistics.",
   vehicles: [
  {
    title: "Tata Ace",
    serial: "",
    image: global.fleet + "tata.png",
    specs: [
      { label: "Length", value: "7.2ft" },
      { label: "Height", value: "5ft" },
      { label: "Width", value: "4.5ft" },
      { label: "Range", value: "110Km" },
      { label: "Weight Capacity", value: "1000Kg" },
    ],
  },
  {
    title: "Euler",
    serial: "",
    image: global.fleet + "euler.png",
    specs: [
      { label: "Length", value: "8.2ft" },
      { label: "Height", value: "6ft" },
      { label: "Width", value: "5ft" },
      { label: "Range", value: "110Km" },
      { label: "Weight Capacity", value: "1000Kg" },
    ],
  },
  {
    title: "JEM",
    serial: "",
    image: global.fleet + "jem.png",
    specs: [
      { label: "Length", value: "7.8ft" },
      { label: "Height", value: "6ft" },
      { label: "Width", value: "4.8ft" },
      { label: "Range", value: "180Km" },
      { label: "Weight Capacity", value: "1000Kg" },
    ],
  },
  {
    title: "Eicher",
    serial: "",
    image: global.fleet + "eicher.png",
    specs: [
      { label: "Length", value: "10.8ft" },
      { label: "Height", value: "7ft" },
      { label: "Width", value: "6.5ft" },
      { label: "Range", value: "130Km" },
      { label: "Weight Capacity", value: "1500Kg" },
    ],
  },
]

  },

  booking: {
    background: global.booking + "bg-map.png",
    image: global.booking + "pic1.png",
    imageBack: "",
    title: "Current Operations",
    subtitle: "Booking For Product Transformation",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.",
    form: {
      quote: global.booking + "icon1.png",
      track: global.booking + "icon2.png",
    },
  },
  battery: {
    background: global.banner + "battery.png",
  },

  plans: {
    title: "Our Plan",
    subtitle: "The right price for you whoever you are",
    plans: [
      {
        type: "Startup",
        price: "90$",
        benifits: [
          "Additional",
          "Warehouing",
          "Custos Borkerage",
          "Unlimited Transfer",
        ],
      },
      {
        type: "Standard",
        price: "150$",
        benifits: [
          "Additional",
          "Warehouing",
          "Custos Borkerage",
          "Unlimited Transfer",
        ],
      },
      {
        type: "Business",
        price: "260$",
        benifits: [
          "Additional",
          "Warehouing",
          "Custos Borkerage",
          "Unlimited Transfer",
        ],
      },
    ],
  },
};
